module.exports = __webpack_public_path__ + "img/assessmentmodal.819d9e56.svg";